export const ClaimIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9995 8.5H1.99951M1.99951 8.5L5.99951 4.5M1.99951 8.5L5.99951 12.5"
        stroke="white"
      />
    </svg>
  )
}
